/**
 * 存储迁移脚本
 * 将 sessionStorage 中的数据迁移到 localStorage
 * 这个脚本应该在应用启动时运行一次
 */

const migrateStorage = () => {
  try {
    // 需要迁移的键列表
    const keysToMigrate = [
      'access_token',
      'refresh_token',
      'username',
      'role',
      'breedKey',
      'ModelMenuKey',
      'BreedMenuKey',
      'PhenoMenuKey'
    ];

    // 从 sessionStorage 迁移到 localStorage
    keysToMigrate.forEach(key => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        localStorage.setItem(key, value);
        console.log(`Migrated ${key} from sessionStorage to localStorage`);
      }
    });

    // 可选：清理 sessionStorage（如果需要的话）
    // keysToMigrate.forEach(key => {
    //   sessionStorage.removeItem(key);
    // });

    console.log('Storage migration completed');
  } catch (error) {
    console.error('Error during storage migration:', error);
  }
};

export default migrateStorage;
